export default "__VITE_ASSET__DRRBrd_V__"